import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogActions, Button } from '@mui/material';
import { titles } from '../contexts/constants/titles';

interface ConfirmDeleteModalProps {
    open: boolean;
    onClose: () => void;
    onSubmit: (id: any) => void;
    id: any;
    name?: any;
    title: any;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({ open, onClose, onSubmit, id, name, title }) => {
    const [deleteId, setdeleteId] = useState(0);
    const [itemId, setItemId] = useState(0);
    const [itemName, setItemName] = useState('');
    const [itemTitle, setItemTitle] = useState('');

    useEffect(() => {
        setItemId(id);
        setItemName(name || '');
        setItemTitle(title);

    }, [id, name, title]);


    const handleSubmit = () => {
        onSubmit(itemId); // Usamos itemId directamente
        onClose();
    };

    const renderTitle = () => {
        switch (true) {
            case itemTitle === titles[0].title:
                return `¿Está seguro que desea eliminar el equipo ${itemId} - ${itemName}?`;
            case itemTitle === titles[1].title:
                return `¿Está seguro que desea eliminar el usuario ${itemId} - ${itemName}?`;
            case itemTitle === titles[2].title:
                return `¿Está seguro que desea eliminar el reporte ${itemId} con fecha ${itemName}?`;
            case itemTitle === titles[3].title:
                return `¿Está seguro que desea eliminar la actividad ${itemId} - ${itemName}?`;
            case itemTitle === titles[4].title:
                return `¿Está seguro que desea eliminar el personal ${itemId} - ${itemName}?`;
            case itemTitle === titles[5].title:
                return `¿Está seguro que desea eliminar la torre ${itemId}?`;
            case itemTitle === titles[6].title:
                return `¿Está seguro que desea eliminar la actividad ${itemId} - ${itemName}?`;
            case itemTitle === titles[7].title:
                // El borrado de subcontratos es logico: la empresa sale del mantenedor pero
                // su historial en reportes diarios se conserva.
                return `¿Está seguro que desea eliminar la empresa subcontratista ${itemName}?`;
            default:
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{renderTitle()}</DialogTitle>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Cancelar
                </Button>
                <Button onClick={handleSubmit} color="error" variant="contained">
                    Eliminar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDeleteModal;
